import React, { createContext, useContext, useMemo, useState } from 'react';
const defaultGaps = {
    mobileGap: undefined,
    tabletGap: undefined,
    desktopGap: undefined
};
const GridContext = createContext(Object.assign(Object.assign({}, defaultGaps), { setGaps: undefined }));
GridContext.displayName = 'GridContext';
const GridProvider = ({ children, gaps: gapsProp = defaultGaps }) => {
    const [gaps, setGaps] = useState(gapsProp);
    const { mobileGap, tabletGap, desktopGap } = gaps;
    const gridContextProps = useMemo(() => {
        return {
            mobileGap,
            tabletGap,
            desktopGap,
            setGaps
        };
    }, [mobileGap, tabletGap, desktopGap, setGaps]);
    return (React.createElement(GridContext.Provider, { value: gridContextProps }, children));
};
export const useGrid = () => {
    return useContext(GridContext);
};
export default GridProvider;
